<template>
  <div class="goodJob">
    <CommonHeader title="goodJob" />
    <main class="main">
      <transition name="fade">
        <div class="content">
          <h2>{{ $t('Good Job!') }}</h2>
          <h3>{{ $t(`Let's move on`) }}</h3>
        </div>
      </transition>
    </main>
    <CommonFooter />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CommonHeader from '@/components/toolbar/CommonHeader';
import CommonFooter from '@/components/toolbar/CommonFooter';

export default {
  name: 'GoodJob',
  data() {
    this.redirect();
    return {
      loading: true,
    };
  },
  methods: {
    redirect: function () {
      setTimeout(() => {
        console.log(this.currentProject._id);
        this.$router.push({ name: 'ProjectOverview', params: { _id: this.currentProject._id } });
      }, 2000);
    },
  },
  computed: {
    ...mapGetters(['currentProject', 'hasSimplePermissions']),
  },
  components: {
    CommonFooter,
    CommonHeader,
  },
};
</script>
<style>
/* Add the decaration on top */
@font-face {
  font-family: 'Cabin';
  src: url('/static/fonts/Cabin-Regular.ttf') format('ttf');
}
@font-face {
  font-family: 'Montserrat';
  src: url('/static/fonts/Montserrat-Regular.ttf') format('ttf');
}
.goodJob {
  height: 100vh;
  background: url(/static/good-job.jpg) no-repeat center;
  display: flex;
  background-size: 100% 100%;
}
.main {
  width: 100%;
  display: flex;
}
.goodJob .content {
  width: 100%;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.goodJob .content h2 {
  font-size: 30px;
  font-weight: bold;
  font-family: Montserrat;
}
.goodJob .content h3 {
  font-size: 28px;
  font-weight: 100;
}

aside {
  /* background-color: #0F161E; */
  position: relative;
}

.menu {
  border-bottom: 2px solid white;
  font-size: 20px;
  width: 70%;
  margin-top: 30px;
}

.links {
  width: 20em;
}

.links li {
  display: flex;
  align-items: center;
  padding: 20px 5px;
  padding-left: 20px;
  border-bottom: 2px solid #1c2731;
  transition: all ease 0.3s;
  letter-spacing: 1px;
  font-size: 0.875em;
}

.links li:hover {
  background: #e8963a;
}

.links li.projectPlan {
  font-size: 1em;
}

.links li.projectLog {
  padding: 20px 0;
  font-size: 0.8em;
  justify-content: center;
  border-bottom: 0;
  letter-spacing: 1px;
}

.projectLog:before {
  content: '> ';
}

.links li.projectLog:hover {
  background: transparent;
  color: #e8963a;
}

@media (max-width: 768px) {
  aside {
    width: 250px;
  }
  aside .links {
    width: auto;
  }
  .goodJob .content {
    width: 100%;
    padding: 0 20px;
  }
}
@media (max-width: 767px) {
  aside {
    display: none;
  }
  .main {
    width: 100%;
    margin-top: 80px;
  }
  .goodJob .content {
    width: 100%;
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/good-job/GoodJob.vue